<template>
  <transition name="note">
    <div
      v-show="visible"
      ref="wrapper"
      :class="['wrapper', isFocus ? 'z-10' : '']"
      :style="style"
      @click="$emit('clickNote')"
    >
      <!-- ref title 用于拖拽 -->
      <div ref="title" class="note-title">
        <img src="./assets/quotation.png" class="drag-none block absolute top-2" alt="背景" />
        <div class="title-text">{{ userInput.title }}</div>
        <img
          src="../assets/close.svg"
          alt="关闭"
          class="w-4 cursor-pointer"
          @click.stop="$emit('update:visible', false)"
        />
      </div>
      <div class="hr"></div>
      <div class="flex-1 flex flex-col p-4 pb-1">
        <div class="content-text">{{ userInput.content }}</div>
      </div>
    </div>
  </transition>
</template>
<script lang="ts">
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import Position from '../mixins/position';

@Component
export default class SaveAfterShow extends Mixins(Position) {
  @Prop({ type: Boolean }) isFocus: boolean;
  @Prop({ type: Boolean }) visible: Boolean;

  userInput = {
    title: '',
    content: ''
  };

  get style() {
    return {
      top: (this.position.top || 0) + 'px',
      left: (this.position.left || 0) + 'px'
    };
  }

  mounted() {
    this.initPosition();
    this.bindEvents();

    this.$nextTick(() => {
      (this.$refs.noteTitle as HTMLTextAreaElement)?.focus();
    });
  }

  open(
    position: {
      top: number;
      left: number;
    },
    userInput: {
      title: string;
      content: string;
    }
  ) {
    this.$emit('update:visible', true);
    // 填入位置信息
    this.position.top = position.top;
    this.position.left = position.left;
    // 填入内容信息
    this.userInput = userInput;
  }
}
</script>
<style scoped>
.wrapper {
  @apply flex min-h-60 min-w-60 flex-col fixed w-5/6 h-120 max-w-full max-h-full rounded-md overflow-hidden bg-white;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
}

@screen md {
  .wrapper {
    width: 476px;
    height: 269px;
  }
}
.drag-none {
  -webkit-user-drag: none;
}

/* title */
.note-title {
  @apply flex items-center justify-between p-4 cursor-move;
  color: #1a051d;
  background: linear-gradient(90deg, rgba(237, 234, 255, 0.4) 7.79%, rgba(237, 234, 255, 0) 50%);
}
.title-text {
  @apply px-6 w-full truncate;
  color: #a89af4;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
}

/* hr */
.hr {
  @apply w-full h-px;
  background: #ececec;
  transform: scaleY(0.5);
}

.content-text {
  color: rgba(63, 51, 86, 0.8);
  font-size: 14px;
}

/* 过渡动画 */
.note-enter,
.note-leave-to {
  opacity: 0;
}
.note-enter-active,
.note-leave-active {
  transition: 0.6s;
}
</style>
